import { useParams } from "react-router-dom";

import Layout from "components/layout/layout";
import ActivityCard from "components/activity_card/ActivityCard";
import DataProvider from "hoc/data_provider";
import useMetadata from "hooks/useMetadata";
import "./department_newsletter.css";

const DepartmentNewsletterPage = () => {
    const { department } = useParams();
    const endPoint = `/web/department/newsletter/${department}`;

    return (
        <DataProvider
            key={department}
            endPoint={endPoint}
            component={DepartmentNewsletter}
        />
    );
};

export default DepartmentNewsletterPage;

const DepartmentNewsletter = ({ data }) => {
    const { proxy } = useMetadata();
    const { name, about, items } = data;

    const newsletterTitle = name || "Departmental Newsletter";

    const activities = (items || []).map((item) => ({
        title: item.title,
        description: "",
        images: item.file ? [`${proxy}/download/files/${item.file}`] : [],
        report: item.link,
    }));

    return (
        <Layout
            title={newsletterTitle}
            breadcrumb={[
                { name: "Home", path: "/" },
                { name: newsletterTitle },
            ]}
        >
            <div className="coe-page">
                <div className="coe-page-data">
                    <div className="coe-about">
                        <h3 className="coe-info-title">About {newsletterTitle}</h3>
                        <p className="coe-desc">{about}</p>
                    </div>
                </div>
                <div className="coe-labs" id="newsletters">
                    <h3 className="coe-info-title">Newsletters</h3>
                    <div className="coe-labs-list">
                        {activities.length > 0 ? (
                            <ActivityCard activities={activities} />
                        ) : (
                            <p className="no-data">Newsletter issues will be updated here...</p>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};
